// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ErrorBoundary_wrapper__1Wj1X","heading":"ErrorBoundary_heading__2zcJ9","description":"ErrorBoundary_description__2KNhp"};